import { render, staticRenderFns } from "./outOrder.vue?vue&type=template&id=197c6b8a&scoped=true&"
import script from "./outOrder.vue?vue&type=script&lang=js&"
export * from "./outOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197c6b8a",
  null
  
)

export default component.exports